import CommonNavbar from "../../Common/CommonLayout/CommonNavbar";
import CommonFooter from "../../Common/CommonLayout/CommonFooter";
import Form from "react-bootstrap/Form";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  // Input,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  CardHeader,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../Constant.js";
import { useNavigate } from 'react-router-dom';
import { Input } from "reactstrap";

const NonPatientPersonalDetails = () => {
  const navigate = useNavigate();

  const firstName = localStorage.getItem("firstName");
  const lastName = localStorage.getItem("lastName");

  const [gender, setgender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");


  const [maritalStatusId, setMaritalStatusId] = useState(0);
  const [countryId, setCountryId] = useState(0);
  const [stateId, setStateId] = useState(0);
  const [streetAdderess, setStreetAdderess] = useState("");
  const [pincode, setPincode] = useState(false);
  const [RelationWithPatientId, setRelationWithPatientId] = useState(false);


  const [maritalStatus, setMaritalStatus] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [relationsWithPatient, setRelationsWithPatient] = useState([]);

  useEffect(() => {
    fetchMaritalStatus();
    fetchCountries();
    fetchRelationsWithPatient();
  }, []);

  const handleCountryChange = (event) => {
    const selectedId = event.target.value;
    setCountryId(selectedId);
    fetchStates(selectedId);
  };

  const fetchStates = async (countryId) => {
    if (!countryId) return;
    try {
      const response = await fetch(
        `${API_URL}Masters/GetStateList/${countryId}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched States:", data);

      if (data && Array.isArray(data.data)) {
        setStates(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setStates([]);
    }
  };

  const fetchMaritalStatus = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetMaritalStatusList", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch MaritalStatus. Status: " + response.status);
      }
      const result = await response.json();
      setMaritalStatus(result.data || []);
    } catch (error) {
      console.error("Error during MaritalStatus fetching:", error.message);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetCountryList", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch Country. Status: " + response.status);
      }
      const result = await response.json();
      setCountries(result.data || []);
    } catch (error) {
      console.error("Error during Country fetching:", error.message);
    }
  };

  const fetchRelationsWithPatient = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetRelationWithPatientList", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to fetch Relations With Patient. Status: " + response.status);
      }
      const result = await response.json();
      setRelationsWithPatient(result.data || []);
    } catch (error) {
      console.error("Error during Relations With Patient fetching:", error.message);
    }
  };

  const handleSave = async (event) => {
    event.preventDefault();
    // if (!validateForm()) return;

    const CurrentDate = new Date().toISOString();

    const data = {
      NonPatientDetailId:0,
      LoginId: localStorage.getItem("loginId"),
      Gender: gender,
      DateOfBirth: dateOfBirth,
      MaritalStatusId: maritalStatusId,
      CountryId: countryId,
      StateId: stateId,
      StreetAdderess: streetAdderess,
      Pincode: pincode,
      RelationWithPatientId: RelationWithPatientId,
      createdOn: CurrentDate,
      isActive: true,
      isDelete: false
    };

    alert("Data is : " + JSON.stringify(data))

    try {
      const response = await fetch(API_URL + "api/Client/SaveNonPatientDetails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const result = await response.json();
        alert("Details Saved Successfully");

        console.log("Client Account Created successfully:", result);
        navigate("/client/patient-details");

      } else {
        const errorText = await response.text();
        console.error("Error during save:", errorText);
      }
    } catch (error) {
      console.error("Error during save:", error);
    }
  }


  return (
    <div>
      <CommonNavbar />
      <Card
        style={{
          width: "700px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
          border: "1px solid gray",
          borderRadius: "10px",
          marginLeft: "26%",
          padding: "20px",
        }}
      >
        <Card.Body>
          <Card.Text>
            <center>
              <Card.Title>Non Patient Personal Details</Card.Title>
            </center>
            <hr />
            <h6>Welcome {firstName} !</h6>
            <br />
            <Form>
              <Form.Group className="mb-3" controlId="formGender">
                <Form.Label>Gender  <b style={{ color: "red" }}>*</b></Form.Label>
                <Form.Select className="form-control"
                  value={gender}
                  onChange={(e) => setgender(e.target.value)}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Female">Other</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formDateOfBirth">
                <Form.Label>Date Of Birth <b style={{ color: "red" }}>*</b></Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Date Of Birth"
                  onChange={(e) => setDateOfBirth(e.target.value)
                  }
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMaritalStatus">
                <Form.Label>Marital Status  <b style={{ color: "red" }}>*</b></Form.Label>
                <Form.Select
                  className="form-control"
                  value={maritalStatusId}
                  onChange={(e) => setMaritalStatusId(e.target.value)}
                >
                  <option value="">Select Marital Status</option>
                  {maritalStatus.map((item) => (
                    <option key={item.maritalStatusId} value={item.maritalStatusId}>
                      {item.maritalStatus}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formCountry">
                <Form.Label>Country  <b style={{ color: "red" }}>*</b></Form.Label>
                <Form.Select
                  className="form-control"
                  onChange={handleCountryChange}
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option
                      key={country.countryId}
                      value={country.countryId}
                    >
                      {country.countryName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formState">
                <Form.Label>State  <b style={{ color: "red" }}>*</b></Form.Label>
                <Form.Select
                  className="form-control"
                  value={stateId}
                  onChange={(e) => setStateId(e.target.value)}
                >
                  <option value="">Select States</option>
                  {states.map((item) => (
                    <option key={item.stateId} value={item.stateId}>
                      {item.stateName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formStreetAddress">
                <Form.Label>Street Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Street Address"
                  onChange={(e) => setStreetAdderess(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPincode">
                <Form.Label>Pincode</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Pincode"
                  onChange={(e) => setPincode(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formRelationWithPatient">
                <Form.Label>Relation With Patient  <b style={{ color: "red" }}>*</b></Form.Label>
                <Form.Select
                  className="form-control"                 
                  onChange={(e) => setRelationWithPatientId(e.target.value)}
                >
                  <option value="">Select Relation With Patient</option>
                  {relationsWithPatient.map((item) => (
                    <option key={item.relationId} value={item.relationId}>
                      {item.relationWithPatient}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>


              <center>
                <Button
                  variant="primary"
                  type="submit"
                  onClick={handleSave}
                >
                  Submit
                </Button>
              </center>
            </Form>
          </Card.Text>
        </Card.Body>
      </Card>



      <br />




      <CommonFooter />
    </div>
  );
};


export default NonPatientPersonalDetails;

